import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\Invoice\UpdateAccountingCodeInvoiceItem::__invoke
* @see app/Http/Controllers/Invoice/UpdateAccountingCodeInvoiceItem.php
* @route '/api/invoicing/{invoice}/invoice-item/{invoice_item}/accounting-code'
*/
const UpdateAccountingCodeInvoiceItem = (args: { invoice: string | number | { id: string | number }, invoice_item: string | number | { id: string | number } } | [invoice: string | number | { id: string | number }, invoice_item: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateAccountingCodeInvoiceItem.url(args, options),
    method: 'put',
})

UpdateAccountingCodeInvoiceItem.definition = {
    methods: ["put"],
    url: '/api/invoicing/{invoice}/invoice-item/{invoice_item}/accounting-code',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\Invoice\UpdateAccountingCodeInvoiceItem::__invoke
* @see app/Http/Controllers/Invoice/UpdateAccountingCodeInvoiceItem.php
* @route '/api/invoicing/{invoice}/invoice-item/{invoice_item}/accounting-code'
*/
UpdateAccountingCodeInvoiceItem.url = (args: { invoice: string | number | { id: string | number }, invoice_item: string | number | { id: string | number } } | [invoice: string | number | { id: string | number }, invoice_item: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            invoice: args[0],
            invoice_item: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        invoice: typeof args.invoice === 'object'
        ? args.invoice.id
        : args.invoice,
        invoice_item: typeof args.invoice_item === 'object'
        ? args.invoice_item.id
        : args.invoice_item,
    }

    return UpdateAccountingCodeInvoiceItem.definition.url
            .replace('{invoice}', parsedArgs.invoice.toString())
            .replace('{invoice_item}', parsedArgs.invoice_item.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\Invoice\UpdateAccountingCodeInvoiceItem::__invoke
* @see app/Http/Controllers/Invoice/UpdateAccountingCodeInvoiceItem.php
* @route '/api/invoicing/{invoice}/invoice-item/{invoice_item}/accounting-code'
*/
UpdateAccountingCodeInvoiceItem.put = (args: { invoice: string | number | { id: string | number }, invoice_item: string | number | { id: string | number } } | [invoice: string | number | { id: string | number }, invoice_item: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateAccountingCodeInvoiceItem.url(args, options),
    method: 'put',
})

export default UpdateAccountingCodeInvoiceItem